module.exports = __webpack_public_path__ + "img/glitter_2.ec35c9e7.jpg";